// extracted by mini-css-extract-plugin
module.exports = {"tag":"GroupCreateDialog_tag__zL11v","modalContent":"GroupCreateDialog_modalContent__GL_8Q"};